import { render, staticRenderFns } from "./WsStudyGroupsList.vue?vue&type=template&id=66f5e586&scoped=true"
import script from "./WsStudyGroupsList.vue?vue&type=script&lang=js"
export * from "./WsStudyGroupsList.vue?vue&type=script&lang=js"
import style0 from "./WsStudyGroupsList.vue?vue&type=style&index=0&id=66f5e586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f5e586",
  null
  
)

export default component.exports